var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Close",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "SF Symbol / xmark",
    d: "M13.3981 25.5751C12.9834 25.9898 12.9749 26.7262 13.4066 27.1578C13.8467 27.5894 14.583 27.581 14.9893 27.1747L19.9997 22.1643L25.0016 27.1663C25.4248 27.5894 26.1527 27.5894 26.5843 27.1578C27.016 26.7177 27.016 25.9983 26.5928 25.5751L21.5908 20.5732L26.5928 15.5628C27.016 15.1396 27.0244 14.4117 26.5843 13.9801C26.1527 13.5484 25.4248 13.5484 25.0016 13.9716L19.9997 18.9736L14.9893 13.9716C14.583 13.5569 13.8382 13.54 13.4066 13.9801C12.9749 14.4117 12.9834 15.1565 13.3981 15.5628L18.4001 20.5732L13.3981 25.5751Z",
    fill: "#E6EEFA"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.fecfd8c5fd17ef2f7c6494f37c83e31a.svg";
export { ForwardRef as ReactComponent };